import clsx from "clsx";
import Image from "next/legacy/image";

import type { FCWithChildren } from "koljobs-types";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  project: { siteName },
} = getPublicConfig();

export const SectionBanner: FCWithChildren<{
  containerClassName?: string;
  overlayClassName?: string;
}> = ({ children, containerClassName, overlayClassName }) => {
  return (
    <div className="bg-primary">
      <div
        className={clsx(
          "relative inline-flex h-20 w-full items-center justify-center sm:h-44",
          containerClassName,
        )}
      >
        <Image
          className="opacity-30"
          alt={siteName}
          src="/images/section_bkg.jpeg"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
        <div
          className={clsx(
            "absolute inset-0 bg-black opacity-30",
            overlayClassName,
          )}
        />
        <h1 className="z-10 text-2xl font-normal text-white sm:text-5xl">
          {children}
        </h1>
      </div>
    </div>
  );
};
